/**
 * 運用管理（Governance）・教育（Training）画面の新しい文言（ja / en）。i18n.ts が合成する。
 * 見出し・ボタンは「〜する」の能動形。制度用語（ルール名・文書名・根拠・委託先の状態）は訳さない。
 */
export const ja: Record<string, string> = {
  "gov.col.actions": "操作",

  "gov.rules.empty": "数値ルールはまだありません",
  "gov.rules.changeAction": "値を変更する",
  "gov.rules.saveAction": "新しい版を追記する",
  "gov.rules.saved": "新しい版を追記しました",

  "gov.docs.empty": "規程文書はまだありません",
  "gov.docs.historyAction": "履歴を見る",
  "gov.docs.historyTitle": "{title} の版の履歴",
  "gov.docs.noVersions": "版はまだありません。",
  "gov.docs.addVersionAction": "版を追加する",
  "gov.docs.fileHint": "25MB までのファイルを選べます。",
  "gov.docs.saveAction": "版を追記する",
  "gov.docs.saved": "版を追記しました",

  "gov.ca.empty": "是正措置はまだありません",
  "gov.ca.addAction": "指摘を起票する",
  "gov.ca.noteLabel": "対応メモ",
  "gov.ca.saved": "起票しました",
  "gov.ca.m.IN_PROGRESS": "着手しました",
  "gov.ca.m.DONE": "完了にしました",
  "gov.ca.m.CARRIED_OVER": "次のサイクルに持ち越しました",

  "gov.vd.empty": "該当する照会はありません",
  "gov.vd.filterLabel": "委託先で絞り込む",
  "gov.vd.notNeededAction": "不要にする",
  "gov.vd.movedSent": "送付済にしました",
  "gov.vd.movedAnswered": "回答受領にしました",
  "gov.vd.movedNotNeeded": "不要にしました",

  "gov.us.empty": "利用者はいません",
  "gov.us.email": "メール・部署",
  "gov.us.do.SUSPENDED": "停止する",
  "gov.us.do.RETIRED": "退職を記録する",
  "gov.us.do.ACTIVE": "復帰させる",
  "gov.us.pseudoAction": "仮名化する",
  "gov.us.pseudoDone": "仮名化しました",

  "gov.audit.filterLabel": "操作で絞り込む",
  "gov.audit.verifyAction": "チェーンを検証する",
  "gov.audit.empty": "該当する記録はありません",
  "gov.audit.limit": "新しい順に {n} 件を表示しています",

  "trn.openAction": "開催を登録する",
  "trn.opened": "開催を登録しました",
  "trn.mine.title": "あなたの受講",
  "trn.mine.count": "受講が必要な教育が {n} 件あります",
  "trn.mine.allDone": "いま受講が必要な教育はありません。",
  "trn.myStatus": "あなたの状況",
  "trn.badge.completed": "受講済み",
  "trn.badge.assigned": "未受講",
  "trn.badge.notAssigned": "対象外",
  "trn.badge.closed": "締切済み",
  "trn.pending.none": "未受講の人はいません。",
};

export const en: Record<string, string> = {
  "gov.col.actions": "Actions",

  "gov.rules.empty": "No numeric rules yet",
  "gov.rules.changeAction": "Change value",
  "gov.rules.saveAction": "Add a new version",
  "gov.rules.saved": "Added a new version",

  "gov.docs.empty": "No policy documents yet",
  "gov.docs.historyAction": "View history",
  "gov.docs.historyTitle": "Version history: {title}",
  "gov.docs.noVersions": "No versions yet.",
  "gov.docs.addVersionAction": "Add a version",
  "gov.docs.fileHint": "You can choose a file up to 25 MB.",
  "gov.docs.saveAction": "Add the version",
  "gov.docs.saved": "Added the version",

  "gov.ca.empty": "No corrective actions yet",
  "gov.ca.addAction": "Log a finding",
  "gov.ca.noteLabel": "Progress note",
  "gov.ca.saved": "Finding logged",
  "gov.ca.m.IN_PROGRESS": "Marked as in progress",
  "gov.ca.m.DONE": "Marked as done",
  "gov.ca.m.CARRIED_OVER": "Carried over to the next cycle",

  "gov.vd.empty": "No matching inquiries",
  "gov.vd.filterLabel": "Filter by vendor",
  "gov.vd.notNeededAction": "Mark as not needed",
  "gov.vd.movedSent": "Marked as sent",
  "gov.vd.movedAnswered": "Marked as answered",
  "gov.vd.movedNotNeeded": "Marked as not needed",

  "gov.us.empty": "No users",
  "gov.us.email": "Email / department",
  "gov.us.do.SUSPENDED": "Suspend",
  "gov.us.do.RETIRED": "Record retirement",
  "gov.us.do.ACTIVE": "Reinstate",
  "gov.us.pseudoAction": "Pseudonymize",
  "gov.us.pseudoDone": "Pseudonymized",

  "gov.audit.filterLabel": "Filter by action",
  "gov.audit.verifyAction": "Verify the chain",
  "gov.audit.empty": "No matching records",
  "gov.audit.limit": "Showing the latest {n} entries",

  "trn.openAction": "Register a session",
  "trn.opened": "Session registered",
  "trn.mine.title": "Your training",
  "trn.mine.count": "You have {n} training session(s) to complete",
  "trn.mine.allDone": "You have no training to complete right now.",
  "trn.myStatus": "Your status",
  "trn.badge.completed": "Completed",
  "trn.badge.assigned": "Not completed",
  "trn.badge.notAssigned": "Not assigned",
  "trn.badge.closed": "Closed",
  "trn.pending.none": "Nobody is waiting to complete this.",
};
